import { createApp } from "vue";
import "./style.css";
import App from "./App.vue";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";

// AG Grid 모듈 등록
ModuleRegistry.registerModules([AllCommunityModule]);

import router from "./router";
createApp(App).use(router).mount("#app");
